import React from "react";
import footerLogo from "../../images/xometry-logo-light.png";
import {
  SimpleFooterBase,
  FooterCopyWrapper,
  FooterCopy,
} from "./simple-footer.styled";

const SimpleFooter = () => {
  return (
    <SimpleFooterBase>
      <FooterCopyWrapper>
        <FooterCopy>
          © {new Date().getFullYear()} Xometry, All Rights Reserved
        </FooterCopy>
        <FooterCopy>ITAR Registered</FooterCopy>
      </FooterCopyWrapper>
    </SimpleFooterBase>
  );
};

export default SimpleFooter;
